export default "__VITE_ASSET__0c5b11f3__"